<template>
  <v-navigation-drawer
    id="drawer"
    app
    mini-variants
    v-model="drawer"
    :mini-variant="mini"
    :dark="$vuetify.dark"
  >
    <v-toolbar @click="redirectTo" class="pa-0" style="cursor: pointer;" >
      <v-img src="../assets/logo-minedu-2025-sm.png" class="logo" />
    </v-toolbar>
    <!-- <div class="logo">
      <img src="../assets/logo-minedu-2025.png" alt="" class="logo" />
    </div> -->
    <v-divider></v-divider>
    <v-list nav dense link class="mb-4">
      <v-subheader>
        <span v-show="!mini">Menús</span>
        <v-spacer></v-spacer>
        <!-- <v-icon @click.stop="draweMini" color="teal">{{ icon_mini }}</v-icon> -->
      </v-subheader>
      <div v-for="(link, i) in menu" :key="i" >
        <v-list-item  
          v-if="!link.submenu"
          :to="link.path"
          active-class="highlighted"
          exact
        >
          <v-list-item-icon class="iconMenu" >
            <v-icon >{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="link.text" />
        </v-list-item>

        <v-list-group 
          v-else
          :key="link.text"
          no-action
          :prepend-icon="link.icon"
          :value="false"
          class="iconMenu"
        >
          <template v-slot:activator class="iconMenu" >
            <v-list-item-title   >{{ link.text }}</v-list-item-title>
          </template>

          <v-list-item  
            v-for="sublink in link.submenu"
            :to="sublink.path"
            :key="sublink.text"
            active-class="grey lighten-3"
            exact
          >
            <v-list-item-title >{{ sublink.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import Service from "../utils/general";
  import Navigation from "../services/menu";
  export default {
    data: () => ({
      mini: false,
      icon_mini: "mdi-transfer-left",
      drawer: true,
      auth_menu: [
        /* {
          text: "Instituciones",
          path: "/instituciones",
          icon: "mdi-bank",
        },
        {
          text: "Inscripción",
          path: "/inscripcion",
          icon: "mdi-file-account",
        }, */
        /* {
          text: "Administración",
          icon: "mdi-cog",
          submenu: [
            {
              text: "Habilitar evento",
              path: "/habilitar/curso",
              icon: "mdi-check",
            },
            {
              text: "Comunicados",
              path: "/comunicado",
              icon: "mdi-check",
            },
            {
              text: "Test Categorías",
              path: "/categoria",
              icon: "mdi-check",
            },
            {
              text: "Test Preguntas",
              path: "/pregunta",
              icon: "mdi-check",
            },
            {
              text: "Test Respuestas",
              path: "/respuesta",
              icon: "mdi-check",
            },
          ],
        }, */
      ],
      menu: [],
      menuCaja: [],
      menuResponsable: [],
      menuAuth: [],
    }),
    created() {
      window.getApp.$on("DRAWER_TOGGLE", () => {
        this.drawer = !this.drawer;
      });
    },
    computed: {
      isAuth() {
        return this.$store.getters.isAuthenticated;
      },
      role() {
        return this.$store.getters.getRole;
      },
    },
    mounted() {
      let rol = Service.getUser() ? Service.getUser().rid : 0;
      this.menu = Navigation.setMenu(rol);
    },
    methods: {
      draweMini() {
        this.mini = !this.mini;
        if (this.mini) {
          this.icon_mini = "mdi-transfer-right";
        } else {
          this.icon_mini = "mdi-transfer-left";
        }
      },
      redirectTo() {
        if (this.$router.currentRoute.name != "root") {
          this.$router.replace({ name: "root" });
        }
      },
    },
  };
</script>

<style lang="css" scoped>
  #drawer {
    overflow: hidden;
  }
  #drawer .drawer-menu--scroll {
    height: calc(100vh - 48px);
    overflow: auto;
  }
  /* .v-application--is-ltr
    .v-list--dense.v-list--nav
    .v-list-group--no-action
    > .v-list-group__items
    > .v-list-item {
    padding: 2 4px;
  } */
  #drawers {
    background-color: #e0f7fa;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(240,960,476)'%3E%3Cstop offset='0' stop-color='%23e0f7fa'/%3E%3Cstop offset='1' stop-color='%23ffffff'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='385' height='320.8' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.02'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
  }
  .v-application--is-rtl .v-list-item__action:first-child,
.v-application--is-rtl .v-list-item__icon:first-child {
  margin-left: 16px !important;
}
.v-application--is-rtl .v-list-item__action:last-of-type:not(:only-child),
.v-application--is-rtl .v-list-item__icon:last-of-type:not(:only-child) , .iconMenu, .v-list-group,
.v-list-item__icon .v-list-group__header__prepend-icon {
  margin-right: 16px !important;
} 
  
</style>
